import React, { useState, useEffect } from "react";
import Navbar from "../components/navigation/Navbar";
import { useSelector, useDispatch } from "react-redux";

import {
  selectAthlete,
  selectActivities,
  viewStravaWebhook,
  getStravaProfileCol,
  getStravaActivityCol,
  selectWebhookDetails,
} from "../features/strava/stravaSlice";

import { selectUser } from "../features/user/userSlice";

function UserProfile() {
  const [authedStrava, setAuthedStrava] = useState(true);

  const dispatch = useDispatch();
  const athlete = useSelector(selectAthlete);
  const activities = useSelector(selectActivities);
  const user = useSelector(selectUser);

  const webhookDetails = useSelector(selectWebhookDetails);

  // Note: for debugging ...
  useEffect(() => {
    console.log("UserProfile MOUNTED");
    console.log("webhookDetails:  ", webhookDetails);

    return () => {
      console.log("UserProfile UNMOUNTED");
    };
  }, []);

  // Note: for debugging ...
  useEffect(() => {
    console.log("athlete info: ", athlete);
  }, [athlete]);

  // TODO: retry until all activities deleted and also profile info removed
  // TODO
  const handleStravaDeAuthClick = () => {
    setAuthedStrava(false); //TODO: this should be based on whether have Strava Profile data ...
    // Note: this should set off a webhook event of type athlete
    window.open("https://www.strava.com/settings/apps", "_blank");
  };

  useEffect(() => {
    dispatch(getStravaProfileCol({ userId: user.$id })).unwrap();
  }, [authedStrava]); // Note: re-fetch profile info to confirm all user strava data deleted

  const refreshPage = () => {
    window.location.reload();
  };

  const connectToStrava = () => {
    const clientId = process.env.REACT_APP_STRAVA_CLIENT_ID;
    if (process.env.NODE_ENV === "development") {
      console.log("clientId: ", clientId);
    }
    const redirectUri =
      process.env.NODE_ENV === "development"
        ? "http://localhost:3000/registered/strava-callback"
        : "https://sunnycodesapp.com/registered/strava-callback";

    const requiredScope = "activity:read"; // Note: previously read_all
    const authStravaAccessUrl = `https://www.strava.com/oauth/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}&approval_prompt=auto&scope=${requiredScope}`;

    window.location.href = authStravaAccessUrl;
  };

  const handleViewWebhookClick = async () => {
    try {
      await dispatch(
        viewStravaWebhook({ webhook: "viewSubscription" })
      ).unwrap();
    } catch (err) {
      console.log("UserProfile: handleViewWebhookClick:", err);
    }
  };

  console.log("UserProfile: user: ", user);

  const webhookDataToRender = () => {
    // Note: { "details": { "created": "2025-02-26T02:58:33+00:00", "updated": "2025-02-26T02:58:33+00:00" }, "subscriptionStatus": "Active webhook subscriptions found." }
    return (
      <>
        <p>
          Realtime connection established since:{" "}
          {webhookDetails?.details?.updated}
        </p>
        <p>Realtime connection status: {webhookDetails?.subscriptionStatus}</p>
      </>
    );
  };

  const athleteDataToRender = () => {
    return Object.entries(athlete).map(([key, value]) => {
      return (
        <p key={key}>
          <strong>{key}: </strong>
          {value?.toString()}
        </p>
      );
    });
  };

  return (
    <>
      <Navbar />
      <h1>User Profile Page</h1>
      {webhookDetails ? webhookDataToRender() : ""}

      <button onClick={handleViewWebhookClick}>
        View Strava Realtime Updates Status
      </button>

      {athlete ? (
        <>
          <h3>Your Strava Profile Info</h3>
          {athleteDataToRender()}
        </>
      ) : (
        <>
          {" "}
          <h3>Your Strava Profile Info</h3>
          <p>No data.</p>
        </>
      )}
      {authedStrava ? (
        <button onClick={handleStravaDeAuthClick}>Deauthorize Strava</button>
      ) : (
        <button onClick={connectToStrava}>Authorize Strava</button>
      )}
    </>
  );
}

export default UserProfile;
